export default {
  Schema: {
    Create: "SchemaCreate",
    Update: "SchemaUpdate",
    Delete: "SchemaDelete",
  },
  Schedule: {
    Create: "ScheduleCreate",
    Update: "ScheduleUpdate",
    ParticipantBulkUpdate: "ScheduleParticipantBulkUpdate",
    TimeScheduleBulkUpdate: "ScheduleTimeScheduleBulkUpdate",
  },
  TakeSurvey: {
    Create: "TakeSurveyCreate",
  },
  Result: {
    Update: "ResultUpdate",
  },
} as const;
